import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Typography } from '@material-ui/core'

import { TicketByAnswerOption, TicketByStatus } from './components'

import { DashboardCounterCard } from 'components'

import constants from 'constants/index'

const DashboardTicket = ({ ticketStats }) => {
  const { ticket: ticketIds } = constants.myLgpd.GRAPH_IDS

  const tickets = ticketStats?.tickets || []

  const totalTickets = Object.values(tickets?.statusCount || {}).reduce(
    (acc, count) => acc + count,
    0,
  )

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h4" color="primary">
          Solicitação de Titulares
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <DashboardCounterCard
            label="Quantidade Total de Solicitação de Titulares"
            value={totalTickets}
            sizes={{ xs: 12, md: 3 }}
          />
          <Grid item xs={12} md={4}>
            <TicketByAnswerOption
              answerOptionCounts={tickets?.answerOptionCounts}
              id={ticketIds.ticketByAnswerOption}
            />
          </Grid>
          <Grid item xs={12} md={5}>
            <TicketByStatus
              ticketStatusCount={tickets?.statusCount}
              id={ticketIds.ticketByStatus}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

DashboardTicket.propTypes = {
  ticketStats: PropTypes.object.isRequired,
}

export default DashboardTicket
